import "./GarageDoorRepairSouthSydney.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import GarageServices from "./sections/GarageServices";
import Southsydneyservices from "./sections/Southsydneyservices";
import Partners from "./sections/Partners";
import ServiceProcessSteps from "./sections/ServiceProcessSteps";
import WhyChooseUs from "./sections/WhyChooseUs";
import ServiceArea from "./sections/ServiceArea";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import GarageFaq from "./sections/GarageFaq";
import CallToAction from "./sections/CallToAction";
import Footer from "./sections/Footer";
export default function GarageDoorRepairSouthSydneyPage() {
  return <div>
      <Header />
      <Hero />
      <GarageServices />
      <Southsydneyservices />
      <Partners />
      <ServiceProcessSteps />
      <WhyChooseUs />
      <ServiceArea />
      <CustomerTestimonials />
      <GarageFaq />
      <CallToAction />
      <Footer />
    </div>;
}